import PropTypes from "prop-types";
import { formatAmount } from "Shared/util/formatters";
import DataTable, { ColumnTypes } from "Shared/components/tables/data-table";
import { translateColumns } from "Shared/util/translations";
import { useTranslation } from "Shared/util/custom-hooks";

const columns = [
  {
    key: "number",
    title: "invoiceNumber",
  },
  {
    key: "debtor",
    title: "customer",
  },
  {
    key: "monitoringReason",
    title: "monitoringReason",
  },
  {
    formatter: (d) => formatAmount(d),
    footer: {
      sum: true,
    },
    key: "totalAmount",
    title: "totalAmount",
    type: ColumnTypes.Amount,
  },
  {
    key: "currencyCode",
    footer: {
      groupBy: true,
    },
    title: "currency",
  },
];

const getRowLink = (row) => `/invoices/${row.id}`;

const InvoiceMonitoredTable = ({ items }) => {
  const tg = useTranslation((x) => x.global);
  return (
    <DataTable
      columns={translateColumns(columns, tg)}
      rows={items}
      getRowLink={getRowLink}
      paging={false}
    />
  );
};

InvoiceMonitoredTable.propTypes = {
  items: PropTypes.array.isRequired,
};

export default InvoiceMonitoredTable;
